<template>
  <div>
    <!-- 未选择迹点 -->
    <div v-if="this.new_item_content==null">请选择要编辑的迹点</div>
    <!-- 已选择迹点 -->
    <div v-else>
      <!-- 简介 -->
      <div style="margin-bottom:10px">
        <div>
          <el-link icon="el-icon-edit"
                   :underline="false"
                   @click="traverInfoDialogVisible=!traverInfoDialogVisible">编辑简介</el-link>
        </div>

        <el-dialog :visible.sync="traverInfoDialogVisible">
          <editor title="简介"
                  :upLoadImgAddress="`${$ip}/add_image?key_name=traver_point_introduce_${this.new_item_content.traver_id}`"
                  :show_content="new_item_content.traver_info"
                  @save="saveTraverInfroduce"></editor>
        </el-dialog>
      </div>
      <!-- 注意事项 -->
      <div style="margin-bottom:10px">
        <div>
          <el-link icon="el-icon-edit"
                   :underline="false"
                   @click="traverRemarkDialogVisible=!traverRemarkDialogVisible">编辑注意事项</el-link>
        </div>

        <el-dialog :visible.sync="traverRemarkDialogVisible">
          <editor title="注意事项"
                  :upLoadImgAddress="`${$ip}/add_image?key_name=traver_point_introduce_${this.new_item_content.traver_id}`"
                  :show_content="new_item_content.traver_remark"
                  @save="saveTraverRemark"></editor>
        </el-dialog>
      </div>
      <el-divider></el-divider>

      <!-- 关联内容 -->
      <div style="margin-bottom:10px">
        <div>
          <i class="el-icon-document-copy">关联内容</i>
          <el-link icon="el-icon-refresh-left"
                   :underline="false"
                   @click="refreshContent"></el-link>
        </div>
        <el-checkbox-group @change="handleCheckAllContent"
                           v-model="new_item_content.content_media">
          <el-checkbox v-for="item,content_id in band_content_list"
                       :label="item"
                       :key="content_id">{{item.content_title}}</el-checkbox>
        </el-checkbox-group>
      </div>

      <!-- 周边推荐 -->
      <div style="margin-bottom:10px">
        <div>
          <i class="el-icon-document-copy">周边推荐</i>
          <el-link icon="el-icon-refresh-left"
                   :underline="false"
                   @click="refreshContent"></el-link>
        </div>

        <el-checkbox-group @change="handleCheckAllRecommends"
                           v-model="new_item_content.recommends">
          <el-checkbox v-for="item,recommend_id in recommend"
                       :label="item"
                       :key="recommend_id">{{item.recommend_name}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <!-- 游玩指南 -->
      <div style="margin-bottom:10px">
        <div>
          <i class="el-icon-document-copy">游玩指南</i>
          <el-link icon="el-icon-refresh-left"
                   :underline="false"
                   @click="refreshContent"></el-link>
        </div>

        <el-checkbox-group @change="handleCheckAllGuide"
                           v-model="new_item_content.guide_group">
          <el-checkbox v-for="item,guide_id in guide"
                       :label="item"
                       :key="guide_id">{{item.guide_title}}</el-checkbox>
        </el-checkbox-group>
      </div>

      <!-- 游玩指南内容修改 -->
      <div v-for="guide,guide_id in new_item_content.guide_group"
           :key="guide_id">
        <el-link icon="el-icon-edit"
                 @click="guideIntroDialogVisible=!guideIntroDialogVisible">编辑游玩指南： {{guide.guide_title}}</el-link>
        <!-- 对话框 -->
        <el-dialog :visible.sync="guideIntroDialogVisible">
          <editor title="游玩指南"
                  :upLoadImgAddress="`${$ip}/add_image?key_name=guide_introduce_${guide.guide_id}`"
                  :show_content="guide.guide_introduce"
                  @save="saveGuideGroup"></editor>
        </el-dialog>
      </div>

      <!-- {{new_item_content}} -->
    </div>

  </div>
</template>

<script>
import Editor from '../../components/common/modify/EditorV2ModifyMini'

export default {
  name: 'traver-detial-change',
  components: {
    Editor,
  },
  data() {
    return {
      traverInfoDialogVisible: false,
      traverRemarkDialogVisible: false,
      guideIntroDialogVisible: false,
      // 新的迹点信息
      new_item_content: this.edit_item_content,
      // 已选关联内容
      band_content_list: this.edit_item_content.content_media,
      // 推荐
      recommend: this.edit_item_content.recommends,
      // 指南
      guide: this.edit_item_content.guide_group,
      change_guide_id: null, // 当前修改的指南id
    }
  },
  watch: {
    edit_item_content(newValue) {
      this.new_item_content = newValue
      this.band_content_list = newValue.content_media
      this.recommend = newValue.recommends
      this.guide = newValue.guide_group
    },
  },
  props: {
    edit_item_content: null,
  },
  methods: {
    handleCheckAllContent(value) {
      this.edit_item_content.content_media = value
    },
    refreshContent() {
      // 通过traver_id重新获取绑定的内容
      this.$http
        .get(
          `/traver/get_traver_point_traver_id?traver_id=${this.new_item_content.id}&source_map=2`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.band_content_list = res.data.data.content_media
            this.recommends = res.data.data.recommends
            this.guide = res.data.data.guide_group
          }
        })
    },
    handleCheckAllRecommends(value) {
      this.edit_item_content.recommends = value
    },
    handleCheckAllGuide(value) {
      this.edit_item_content.guide_group = value
    },
    saveTraverInfroduce(value) {
      this.new_item_content.traver_info = value
      // console.log(this.new_item_content)
      // this.$emit('changeNewTraverPoint', this.new_item_content)
    },
    saveTraverRemark(value) {
      this.new_item_content.traver_remark = value
    },
    changeGuideGroup(value) {
      this.traverInfoDialogVisible = !this.traverInfoDialogVisible
      this.change_guide_id = value.guide_id
    },
    saveGuideGroup(value) {
      const group_list = this.new_item_content.guide_group
      group_list.forEach((item) => {
        if (item.guide_id == this.change_guide_id) {
          console.log(item)
          item.guide_introduce = value
        }
      })
    },
  },
}
</script>

<style>
</style>